// import Layout from '../../layouts/FullScreenLayout'
import Forgot from './Forgot'

// export default Layout(Forgot)
export default Forgot
